import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class QueryService {
    private queries = [
        {
            title: 'Unable to add new teacher',
            description: 'Getting error when trying to invite teacher with @sit.ac.in domain',
            date: 'Jan 28, 2024',
            priority: 'High',
            status: 'Open',
        },
        {
            title: 'Batch creation issue',
            description: 'Need help setting up semester-based batches',
            date: 'Jan 27, 2024',
            priority: 'Medium',
            status: 'In Progress',
        },
        {
            title: 'Feature request: Export student data',
            description: 'Would like to export student data to CSV',
            date: 'Jan 25, 2024',
            priority: 'Low',
            status: 'Resolved',
        },
    ];

    getQueries() {
        return of(this.queries);
    }

    submitQuery(newQuery: any) {
        const formatted = {
            title: newQuery.subject,
            description: newQuery.description,
            priority: newQuery.priority,
            status: 'Open',
            date: new Date().toDateString(),
        };
        this.queries.unshift(formatted);
        return of(true);
    }
}
